/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleSearchConsoleSiteData
 */
export interface GoogleSearchConsoleSiteData {
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleSiteData
     */
    siteUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleSiteData
     */
    permissionLevel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleSearchConsoleSiteData
     */
    projectDomainVerified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleSearchConsoleSiteData
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleSiteData
     */
    discoveredAt?: string;
}

/**
 * Check if a given object implements the GoogleSearchConsoleSiteData interface.
 */
export function instanceOfGoogleSearchConsoleSiteData(value: object): value is GoogleSearchConsoleSiteData {
    return true;
}

export function GoogleSearchConsoleSiteDataFromJSON(json: any): GoogleSearchConsoleSiteData {
    return GoogleSearchConsoleSiteDataFromJSONTyped(json, false);
}

export function GoogleSearchConsoleSiteDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSearchConsoleSiteData {
    if (json == null) {
        return json;
    }
    return {
        
        'siteUrl': json['siteUrl'] == null ? undefined : json['siteUrl'],
        'permissionLevel': json['permissionLevel'] == null ? undefined : json['permissionLevel'],
        'projectDomainVerified': json['projectDomainVerified'] == null ? undefined : json['projectDomainVerified'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'discoveredAt': json['discoveredAt'] == null ? undefined : json['discoveredAt'],
    };
}

export function GoogleSearchConsoleSiteDataToJSON(json: any): GoogleSearchConsoleSiteData {
    return GoogleSearchConsoleSiteDataToJSONTyped(json, false);
}

export function GoogleSearchConsoleSiteDataToJSONTyped(value?: GoogleSearchConsoleSiteData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'siteUrl': value['siteUrl'],
        'permissionLevel': value['permissionLevel'],
        'projectDomainVerified': value['projectDomainVerified'],
        'enabled': value['enabled'],
        'discoveredAt': value['discoveredAt'],
    };
}

